import { DashboardShell } from "@/components/dashboard-shell";
import {
  PaceLatencyTimeline,
  PaceRequestStatus,
  PaceSystemLimits,
  PaceTokenRatio,
} from "@/components/charts-demo/pace-widgets-5-8";
import {
  PaceLiveConsole,
  PaceNodeMap,
  PaceResourceDistribution,
  PaceSeatBooking,
} from "@/components/charts-demo/pace-widgets-1-4";
import {
  LatencyTimelineWidget,
  LiveConsoleWidget,
  NodeMapWidget,
  OutreachRatioWidget,
  RequestStatusWidget,
  ResourceDistributionWidget,
  SeatBookingWidget,
  SystemLimitsWidget,
} from "@/components/widgets-demo/ops-widgets";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/widgets-demo")({
  component: WidgetsDemoPage,
  head: () => ({ meta: [{ title: "Widgets Demo" }] }),
});

function WidgetsDemoPage() {
  return (
    <DashboardShell>
      <div className="flex flex-col gap-4">
        <div>
          <h1 className="text-xl font-semibold tracking-tight">Widgets demo</h1>
          <p className="text-sm text-muted-foreground">
            Ops widgets — console, status, latency, ratios, limits, map, seats.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
          <RequestStatusWidget />
          <LatencyTimelineWidget />
        </div>

        <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
          <OutreachRatioWidget />
          <ResourceDistributionWidget />
        </div>

        <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
          <SystemLimitsWidget />
          <NodeMapWidget />
        </div>

        <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
          <LiveConsoleWidget />
          <SeatBookingWidget />
        </div>

        <div className="pt-2">
          <h2 className="text-lg font-semibold tracking-tight">
            Dashboard widgets
          </h2>
          <p className="text-sm text-muted-foreground">
            Activity stream, seats, resources, maps, limits, ratios, latency,
            status.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
          <PaceRequestStatus />
          <PaceLatencyTimeline />
        </div>

        <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
          <PaceTokenRatio />
          <PaceResourceDistribution />
        </div>

        <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
          <PaceSystemLimits />
          <PaceNodeMap />
        </div>

        <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
          <PaceLiveConsole />
          <PaceSeatBooking />
        </div>
      </div>
    </DashboardShell>
  );
}
